var map = {
	"./banco_mundial.png": 8646,
	"./bid.png": 11267,
	"./bing.png": 86046,
	"./contraloria.png": 56389,
	"./escudo-policia.png": 42098,
	"./escudo_colombia.png": 71105,
	"./google.png": 4698,
	"./idb.png": 40441,
	"./inpec.png": 8512,
	"./interpol.jpg": 21558,
	"./interpol_csnu.jpg": 19069,
	"./interpol_red.jpg": 60535,
	"./j_contadores.jpg": 98176,
	"./ofac.png": 68695,
	"./onu.png": 61853,
	"./paco.png": 25334,
	"./procuraduria.png": 41753,
	"./rama_judicial.png": 19706,
	"./rues.png": 82527,
	"./sam.png": 55324,
	"./srvcnpc.png": 87741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3687;